var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('UserInfos')],1),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('UserPassword')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }